var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "bordered rounded-lg",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "primary--text text-h5 pb-0 text-no-wrap"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "large": _vm.$vuetify.breakpoint.smAndUp,
      "left": ""
    }
  }, [_vm._v("mdi-track-light")]), _c('h2', {
    staticClass: "text-h6 text-sm-h5 font-weight-black"
  }, [_vm._v("WEEKLY HIGHLIGHTS")])], 1), _c('v-card-text', {
    staticClass: "d-flex flex-wrap justify-space-between py-6",
    class: _vm.flexOverride ? ("flex-" + (_vm.flexOverride)) : 'flex-column flex-sm-row'
  }, _vm._l(_vm.highlights, function (highlight) {
    return _c('v-card', {
      key: highlight.id,
      staticClass: "flex-grow-1 mt-4 mt-sm-0 mr-2",
      attrs: {
        "href": highlight.url,
        "target": "blank",
        "hover": "",
        "rounded": ""
      }
    }, [_c('v-card-text', {
      staticClass: "d-flex align-center font-weight-bold text-h6",
      class: ((_vm.departmentMap[highlight.department].color) + "--text")
    }, [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "color": _vm.departmentMap[highlight.department].color
      }
    }, [_vm._v(_vm._s(_vm.departmentMap[highlight.department].icon))]), _vm._v(" " + _vm._s(highlight.department.toUpperCase()) + " ")], 1)], 1);
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }